require('./index.less');
require('../../app/app');

var pageConfig = window.pageConfig;
var validate = pageConfig.validate;
var myProjectList = pageConfig.projectList;
var util = require('../../app/util');
var loadData = util.loadData;
var i18n = require('i18n');
var projectDetail = require('./projectDetail.html');
var projectInfo = require('./projectInfo.html');
var deliveryManagement = require('./deliveryManagement.html');
var userItem = require('./userItem.html');
var userList = require('./userList.html');
var addProjectLayer = require('./addProjectLayer');
var cloneProject = require('./cloneProject');
var addUserLayer = require('./addUserLayer');
var indexTPL = require('./index.html');

var currentProjectUsers;
var roleMap = pageConfig.roleMap;
var localUser = {
  id: parseInt(decodeURIComponent(util.getCookie('uid') || ''), 10)
};

// Set nav title selected
$('header div.nav a.my-project').addClass('selected');

function getRoleList(role) {
  var ret = [];
  var self = roleMap[role];

  for (var i in roleMap) {
    if (roleMap[i] >= self) {
      ret.push(i);
    }
  }
  return ret;
}

function showDelBtn(role) {
  return localUser.isCreator || !(roleMap[localUser.role] > roleMap['master'] || roleMap[localUser.role] >= roleMap[role]);
}

function changeUserRole(value, text) {
  var list = $('.project-list');
  var pid = list.find('.selected').data('project-id');
  var user = $(this).data('user');
  var role = value;
  var td = $(this).closest('td');
  var row = $(this).closest('tr');

  loadData('/project/' + pid + '/changeUserRole/' + user, {
    role: role
  }, 'POST', function(res) {
    if (role == localUser.role) {
      td.html(role);
      row.find('td:last .del-user').hide();
      return;
    }

    var btn = '<button data-user="' + user + '" class="ui button del-user" >' + i18n('common.remove') + '</button>';
    var showBtn = showDelBtn(role);

    if (showBtn) { //change user role event
      if (row.find('td:last .del-user').length) {
        row.find('td:last .del-user').show();
      } else {
        row.find('td:last').append(btn);
      }
    } else {
      row.find('td:last .del-user').hide();
    }
  });
}

function updateProjectField($inp) {
  var $field = $inp.parent();
  var projectId = $('.project-info .project-id').text().trim();
  var name = $field.attr('name');
  var value = $inp.val().trim();
  if (name === 'name') {
    if (!value || /^test/.test(value) || value.length > validate.maxProjectName 
      || value.length < validate.minProjectName) {
      $field.html($field.data('lastContent'));
      return
    } 
  }
  if (name === 'desc' && value.length > validate.maxDescription) {
    $field.html($field.data('lastContent'));
    return;
  }

  if (value === $field.data('lastContent')) {
    $field.html(value);
    return;
  }
  loadData('/project/ ' + projectId + '/updateField', {
    field: name,
    value: value
  }, 'POST', function(res) {
    //if (name === 'name' || name === 'description') {
      value = value.replace(/</g,'&lt;');
    //}
    $field.html(value);
    if (name === 'name') {
      $('.project-list li[data-project-id=' + projectId + ']').html(value);
    }
  });
}


var App = {
  init: function() {
    if (pageConfig.error) {
      util.show({
        icon: 'error',
        content: pageConfig.error
      });
      return;
    }

    var list = myProjectList.projects;
    var delList = myProjectList.deletedProjects;
    var indexHTML = indexTPL({
      projectList: list,
      deletedProjectList: delList,
      i18n: i18n()
    });
    $(indexHTML).appendTo($('body'));

    var list = $('.project-list');
    list.on('click', 'li:not(.selected)', function(e) {
      var target = $(e.target);
      var pid = target.data('project-id');

      pid && loadData('/project/' + pid, {}, function(res) {
        var data = res.data;
        if (data) {
          data = handleProjectInfo(data, pid);
          data.pid = pid;
          var html = projectDetail(data);
          $('.project-detail').html(html);

          list.find('.selected').removeClass('selected');
          target.addClass('selected');

          html = projectInfo(data);
          $('.project-wrap').html(html);
        } else {
          target.hide();
        }
      });

      try {
        localStorage.pid = pid;
      } catch (e) {}
    });

    $('body').on('click', '.add-project', function() {
      $('.add-project-layer').modal('show');
    });

    function onAddProject (data) {
      data.name = data.name.replace(/</, '&lt;');
      var $item = $('<li class="elli" data-project-id="' + data.id + '">' + data.name + '</li>');
      $item.prependTo($('.project-list'));


      var empty = $('.add-my-first-project');

      if (empty.length) {
        empty.remove();
        $('.wrapper').css('display', 'table');
      }

      $item.click();
    }
    addProjectLayer(onAddProject);

    cloneProject(onAddProject);

    function handleProjectInfo(data, pid) {

      data.time_created = util.format(data.time_created);
      data.workbenchUrl = location.protocol +
            '//workbench.enhancer.' +
            location.hostname.match(/\w+$/) +
            '/proj/' + pid;

      var found = 0;
      var user;
      localUser.isCreator = data.creator === localUser.id;
      data.showPublic = localUser.isCreator;
      data.is_public = data.is_public === 'Y' && localUser.isCreator;
      data.users.some(function(item) {
        if (item.id == localUser.id) {
          localUser.role = item.role;
          data.showBtn = roleMap[item.role] < roleMap['master']; // 只有 owner才能删除成员, 只有creator 才能删 owner
          data.showEditable = roleMap[item.role] <= roleMap['master']; //  只有owner和master才能编辑标题和描述
          data.showClone = roleMap[item.role] <= roleMap['master']; //  只有owner和master才能克隆项目
          found++;
        }
        if (item.id === data.creator) {
          user = item;
          found++;
        }
        return found > 1;
      });
      data.role = localUser.role;
      data.nickname = user.nickname;
      currentProjectUsers = data.users;
      data.delText = i18n(localUser.id === data.creator ? 'delete' : 'leave');
      return data;
    }

    $('.project-detail').on('click', '.project-tabs > li:not(.selected)', function(e) {
      var target = $(e.target).closest('li');
      var tab = target.data('tab');
      var pid = list.find('.selected').data('project-id');
      var html;

      function changeTab() {
        $('.project-tabs .selected').removeClass('selected')
        target.addClass('selected');
      }

      switch (tab) {
        case 'project-info':
          loadData('/project/' + pid, {}, function(res) {
            if (res.data) {
              var data = handleProjectInfo(res.data, pid);
              html = projectInfo(data);
              $('.project-wrap').html(html);
              changeTab();
            } else {
              target.hide();
            }
          });
          break;
        case 'delivery-management':
          html = deliveryManagement({
            deliveryUrl: '//delivery.enhancer.' +
              location.hostname.match(/\w+$/) +
              '/proj/' + pid + '/release/home'
          });
          $('.project-wrap').html(html);
          changeTab();
          break;
        case 'authorization':
          loadData('/project/' + pid + '/users/', {}, function(res) {
            res.data.forEach(function(item) {
              var itemRole = roleMap[item.role];
              var userRole = roleMap[localUser.role];
              if (item.user_id == localUser.id  || userRole > roleMap['master'] ||  userRole > itemRole || (userRole == itemRole && !localUser.isCreator)) {
                item.showList = false;
              } else {
                item.showList = true;
                item.roleList = getRoleList(localUser.role, item.role);
              }
              var user;
              currentProjectUsers.some(function (it) {
                if (it.id === item.user_id) {
                  user = it;
                  return true;
                }
              })

              if (user) {
                item.nickname = user.nickname;
                item.avatar = user.avatar;
              }
            });

            res.showAddUser = roleMap[localUser.role] <= roleMap['master']; // master 和 owner 都能添加成员  
            html = userList(res);
            $('.project-wrap').html(html);
            changeTab();


            $('.project-wrap .dropdown').dropdown({
              onChange: changeUserRole
            });
          });
          break
      }
    });

    // Grant
    $('.project-detail').on('click', 'a.button.grant-project', function() {
      $(this).parent().parent().parent()
        .prev().find('li[data-tab=authorization]')
        .click();
    });

    // Public
    $('.project-detail').on('click', 'a.button.public-project', function() {
      var self =  this;
      var pid = $(this).attr('data-project-id');
      var open = $(this).find('.icon').hasClass('unlock');

      util.showConfirm( i18n('home.confirm.' + (open ? 'un' : '') + 'public.project'), function() {
        loadData('/project/' + pid + '/public', {
          is_public: !open 
        }, 'POST', function(res) {
          $(self).find('.icon').toggleClass('unlock');
          $(self).find('span').text(i18n((open ? '' : 'un') + 'public.project'));
        });
      }, function() {});
    });

    // Delete
    $('.project-detail').on('click', '.button.delete-project', function(e) {
      var pid = $(this).attr('data-project-id');
      var creator = $(this).attr('data-creator');
      var tip = creator == localUser.id ? 'home.confirm.remove.project' : 'tip.exit';
      
      util.showConfirm(i18n(tip), function() {
        loadData('/project/' + pid + '/delete', {
        }, 'POST', function(res) {
          window.location.reload();
        });
      }, function() {});
    });

    // Clone
    $('.project-detail').on('click', '.button.clone-project', function(e) {
      var pid = $(this).attr('data-project-id');
      var pname = $(this).attr('data-project-name');
      util.showConfirm(i18n('home.clone.tip'), function () {
        var layer = $('.clone-project-layer');
      
        layer.find('input[name=name]').val('New ' + pname);
        layer.find('input[name=desc]').val('Cloned From ' + pname);
        layer.data('pid', pid).data('pname', pname);
        layer.modal('show');
      }, null, i18n('home.sure'));
    });

    $('body').on('click', '.del-project-list-title', function() {
      if ($(this).hasClass('expended')) {
        $(this).removeClass('expended')
          .find('i.caret').removeClass('down').addClass('left');
        $(this).next().hide('blind');
      } else {
        $(this).addClass('expended')
          .find('i.caret').addClass('down').removeClass('left');
        $(this).next().show('blind');
      }
    });

    addUserLayer(function(data) {
      data.showBtn = showDelBtn(data.role);
      $('.project-wrap .developer-list tbody').prepend(userItem(data));

      $('.project-wrap .developer-list tr').eq(1).find('.dropdown').dropdown({
        onChange: changeUserRole
      });
    });

    $('body').on('click', '.add-user', function() {
      $('.add-user-layer .dropdown.role .menu .item[data-value=owner]').toggle(localUser.role === 'owner')
      $('.add-user-layer').modal('show');
    });
    $('body').on('click', '.project-wrap .del-user', function() {
      var uid = $(this).data('user');
      var pid = list.find('.selected').data('project-id');
      var row = $(this).closest('tr');

      util.showConfirm(i18n('home.confirm.remove.user'), function() {
        loadData('/project/' + pid + '/delUser/' + uid, {}, 'POST', function(res) {
          row.remove();
        });
      }, function() {});
    });

    $('body').on('click', '.project-wrap span.editable', function(e) {
      var $this = $(this);
      var lastContent = $this.text().trim();
      $this.data('lastContent', lastContent);
      var $inp = $('<input>').val(lastContent)
        .on('click', function(e) {
          e.stopPropagation();
        })
        .on('keyup', function(e) {
          if (e.keyCode === 13) {
            updateProjectField($(this));
          }
        })
        .on('blur', function(e) {
          updateProjectField($(this));
        })

      $this.html('').append($inp);
      $inp.focus();
    });

    // Undelete
    $('body').on('click', 'i.undelete', function(e) {
      var pid = $(this).closest('li').attr('data-project-id');
      loadData('/project/' + pid + '/undelete', {
      }, 'POST', function(res) {
        window.location.reload();
      });
    });

    // Delete permanent
    $('body').on('click', 'i.delete-permanent', function(e) {
      var pid = $(this).closest('li').attr('data-project-id');
      var pname = $(this).closest('li').find('.deleted-name').html().trim();
      var tips = i18n('removePermanent', {
        name: pname
      });
      util.showConfirm(tips, function() {
        loadData('/project/'  + pid +'/delete', {
          permanent: true
        }, 'POST', function(res) {
          window.location.reload();
        });
      }, function() {});
    });


    
    var empty = '<div class="button add-my-first-project add-project">' +
      '<i class="plus icon "></i>' +
      i18n('home.add.first.project') +
      '</div>';

    $('body').append(empty);

    if (list.find('li').length) {
      var projectId;
      try {
        projectId = localStorage.pid;
      }catch(e) {};

      var li = list.find('li[data-project-id=' + projectId  + ']');
      if (li.length) {
        li.click();
      } else {
        list.find('li:first').click();
      }
    } else {
      $('.wrapper').css('display', 'none');
      $('.add-my-first-project').css('display', 'block');
    }

    if (location.hash) {
      var match = location.hash.match(/project=(\d+)/);
      if (match) {
        $('.project-list li[data-project-id=' + match[1] + ']').click();
      }
    }
  }
};

// Entry
(function() {
  App.init();
})();


// WEBPACK FOOTER //
// ./src/pages/home/index.js